import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import { Client } from '../types';
import './Pages.css';

const Profile: React.FC = () => {
  const [profile, setProfile] = useState<Client | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    loadProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadProfile = async () => {
    try {
      const response = await api.get<Client>('/client/profile');
      setProfile(response.data);
    } catch (error) {
      console.error('Error loading profile:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Carregando...</div>;

  return (
    <div className="page">
      <div className="container">
        <h1>Meu Perfil</h1>
        
        <div className="profile-card">
          <div className="profile-avatar-large">
            {profile?.name?.charAt(0).toUpperCase() || 'U'}
          </div>
          
          <div className="profile-info">
            <h2>{profile?.name}</h2>
            <div className="profile-details">
              <div className="detail-item">
                <span className="detail-label">📱 Telefone:</span>
                <span>{profile?.phone}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">🆔 CPF:</span>
                <span>{profile?.cpf}</span>
              </div>
              {profile?.email && (
                <div className="detail-item">
                  <span className="detail-label">📧 E-mail:</span>
                  <span>{profile.email}</span>
                </div>
              )}
              <div className="detail-item">
                <span className="detail-label">📅 Membro desde:</span>
                <span>{profile?.createdAt ? new Date(profile.createdAt).toLocaleDateString('pt-BR') : ''}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;

